(function () {
  // NOTE: Quick-add functionality moved to product-card-quick-add.js
  // This file now only contains helper functions for cart drawer

  // Guard to prevent duplicate event listener attachment
  if (window.__quickAddInitialized) {
    return;
  }
  window.__quickAddInitialized = true;

  let isUpdating = false;

  const getDrawer = () => document.querySelector('cart-drawer');

  const openDrawer = (drawer) => {
    if (!drawer) {
      console.error('Cart drawer element not found');
      return;
    }
    console.log('Opening cart drawer');
    // Use the custom element's show() method
    if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      // Fallback to manual class manipulation
      drawer.classList.add('is-open');
      drawer.classList.remove('drawer--center-body');
      drawer.setAttribute('open', 'true');
    }
  };

  const updateHeaderCart = () => {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.querySelectorAll('cart-count').forEach(el => {
          el.innerText = cart.item_count;
        });
        document.querySelectorAll('cart-dot').forEach(el => {
          if (cart.item_count > 0) {
            el.classList.add('is-visible');
          } else {
            el.classList.remove('is-visible');
          }
        });
      })
      .catch(e => console.error('Error updating header cart:', e));
  };

  const handleQuickAdd = (event) => {
    console.log('[Quick Add] Click event fired');
    const button = event.target.closest('.quick-add-btn');

    if (!button) {
      return;
    }

    console.log('[Quick Add] Button found, preventing default and stopping propagation');
    event.preventDefault();
    event.stopPropagation();

    if (isUpdating) {
      console.log('[Quick Add] Already updating, ignoring click');
      return;
    }

    console.log('[Quick Add] Setting isUpdating to true');
    isUpdating = true;
    const variantId = button.dataset.variant;
    // HARDCODED: Always add exactly 1 item from product cards, ignore quantity rules
    const quantity = 1;

    if (!variantId) {
      console.error('[Quick Add] No variant ID found in button');
      isUpdating = false;
      return;
    }

    console.log('[Quick Add] Variant ID:', variantId);
    console.log('[Quick Add] Quantity (hardcoded for product cards):', quantity);

    // Store original button content
    const originalButtonHTML = button.innerHTML;

    // Set button to loading state
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    // Change button text to show feedback
    // const loadingText = button.dataset.loadingText || 'Adding...';
    // button.innerHTML = loadingText;
    button.innerHTML = '<div class="loader-spinner-btn"></div>';

    // Trigger theme's loading bar
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', {
      bubbles: true
    }));

    console.log('[Quick Add] ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('[Quick Add] Adding to cart:', { variantId, quantity });
    console.log('[Quick Add] ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');

    // Submit to Shopify Cart API
    const params = new URLSearchParams();
    params.append('id', variantId);
    params.append('quantity', '1'); // Hardcoded to 1 for product card quick-add

    console.log('[Quick Add] Sending POST request to /cart/add.js');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: params.toString()
    })
      .then((response) => {
        console.log('[Quick Add] Response received:', response.status);
        if (!response.ok) {
          return response.json().then((error) => {
            throw error;
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log('[Quick Add] ═══════════════════════════════════════════════════');
        console.log('[Quick Add] ✅ Product added successfully');
        console.log('[Quick Add] Response data:', data);
        console.log('[Quick Add] Quantity in response:', data.quantity);
        console.log('[Quick Add] Product title:', data.product_title);
        console.log('[Quick Add] Variant title:', data.variant_title);
        console.log('[Quick Add] ═══════════════════════════════════════════════════');

        // Verify actual cart state after adding
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            console.log('[Quick Add] ✓ Current cart state:', {
              item_count: cart.item_count,
              total_items: cart.items.length
            });
            const addedItem = cart.items.find(item => item.variant_id === parseInt(variantId));
            if (addedItem) {
              console.log('[Quick Add] ✓ Item in cart:', {
                title: addedItem.product_title,
                variant: addedItem.variant_title,
                quantity: addedItem.quantity,
                line_price: addedItem.line_price
              });
            }
          })
          .catch(err => console.error('[Quick Add] Failed to fetch cart state:', err));

        const drawer = getDrawer();
        if (!drawer) {
          console.error('Cart drawer not found');
          return;
        }

        // Listen for the drawer refresh completion
        const onRefreshed = () => {
          console.log('Cart drawer refreshed, now opening...');
          openDrawer(drawer);
          updateHeaderCart();

          // End loading state
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
            bubbles: true
          }));

          drawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
        };

        drawer.addEventListener('cart-drawer:refreshed', onRefreshed);

        // Trigger cart refresh event that the theme's CartDrawer listens to
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        // Fallback: open after timeout if event doesn't fire
        setTimeout(() => {
          drawer.removeEventListener('cart-drawer:refreshed', onRefreshed);
          openDrawer(drawer);
          updateHeaderCart();

          // End loading state
          document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
            bubbles: true
          }));
        }, 1000);
      })
      .catch((error) => {
        console.error('Unable to add item to cart', error);

        // End loading state on error
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
          bubbles: true
        }));

        if (error.description) {
          alert(error.description);
        } else if (error.message) {
          alert(error.message);
        } else {
          alert('Failed to add item to cart. Please try again.');
        }
      })
      .finally(() => {
        isUpdating = false;
        if (button) {
          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
          button.classList.remove('loading');

          // Restore original button content
          button.innerHTML = originalButtonHTML;
        }
      });
  };

  // DISABLED: Event listener moved to product-card-quick-add.js
  // document.addEventListener('click', handleQuickAdd);
})();

/**
 * Product Compare Manager
 * Handles adding/removing products to/from compare list with localStorage
 */

class ProductCompare {
  constructor() {
    this.storageKey = 'mama_pajama_compare';
    this.maxProducts = 4;
    this.init();
  }

  init() {
    // Initialize compare button handlers
    document.addEventListener('click', (e) => {
      const compareBtn = e.target.closest('.insy-compare');
      if (compareBtn) {
        e.preventDefault();
        e.stopPropagation();
        this.handleCompareClick(compareBtn);
      }
    });

    // Update button states on page load
    this.updateAllButtonStates();
  }

  handleCompareClick(button) {
    const productId = button.dataset.productId;
    const productData = this.extractProductData(button);

    if (!productId || !productData) {
      console.error('Missing product data');
      return;
    }

    const compareList = this.getCompareList();
    const isInCompare = compareList.some(p => p.id === productId);

    if (isInCompare) {
      // Remove from compare
      this.removeFromCompare(productId);
      this.showNotification(window.themeVariables.strings.compareRemoved, 'success');
    } else {
      // Check if limit reached
      if (compareList.length >= this.maxProducts) {
        this.showNotification(window.themeVariables.strings.compareLimitReached.replace('[count]', this.maxProducts), 'warning');
        return;
      }
      // Add to compare
      this.addToCompare(productData);
      this.showNotification(window.themeVariables.strings.compareAdded, 'success');
    }

    this.updateButtonState(button, !isInCompare);
    this.updateCompareCount();
  }

  extractProductData(button) {
    const card = button.closest('.insy-card');
    if (!card) return null;

    const productId = button.dataset.productId;
    const title = card.querySelector('.insy-info h3 a')?.textContent.trim();
    const price = card.querySelector('.insy-info .price')?.textContent.trim();
    const handle = button.dataset.handle;
    const imageElement = card.querySelector('.insy-img.is-primary');
    const image = imageElement?.src || '';

    // Extract variant data
    const variantButton = card.querySelector('.quick-add-btn');
    const variantId = variantButton?.dataset.variant;

    // Get all variant info from swatches if available
    const swatches = card.querySelectorAll('.insy-swatch-item');
    const variants = [];
    swatches.forEach(swatch => {
      variants.push({
        id: swatch.dataset.variantId,
        mediaId: swatch.dataset.mediaId
      });
    });

    // Get product description (if available from data attribute)
    const description = button.dataset.description || '';

    return {
      id: productId,
      title: title,
      price: price,
      image: image,
      handle: handle,
      variantId: variantId,
      variants: variants,
      description: description,
      addedAt: new Date().toISOString()
    };
  }

  getCompareList() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      console.error('Error reading compare list:', e);
      return [];
    }
  }

  saveCompareList(list) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(list));
      // Dispatch event for other components to listen
      window.dispatchEvent(new CustomEvent('compareListUpdated', {
        detail: { count: list.length }
      }));
    } catch (e) {
      console.error('Error saving compare list:', e);
    }
  }

  addToCompare(product) {
    const compareList = this.getCompareList();
    compareList.push(product);
    this.saveCompareList(compareList);
  }

  removeFromCompare(productId) {
    let compareList = this.getCompareList();
    compareList = compareList.filter(p => p.id !== productId);
    this.saveCompareList(compareList);
  }

  clearCompare() {
    this.saveCompareList([]);
    this.updateAllButtonStates();
  }

  updateButtonState(button, isActive) {
    if (isActive) {
      button.classList.add('is-active');
      button.setAttribute('aria-label', 'Remove from compare');
      button.style.background = '#ff6b6b';
    } else {
      button.classList.remove('is-active');
      button.setAttribute('aria-label', 'Add to compare');
      button.style.background = '';
    }
  }

  updateAllButtonStates() {
    const compareList = this.getCompareList();
    const compareIds = compareList.map(p => p.id);

    document.querySelectorAll('.insy-compare').forEach(button => {
      const productId = button.dataset.productId;
      const isActive = compareIds.includes(productId);
      this.updateButtonState(button, isActive);
    });
  }

  updateCompareCount() {
    const count = this.getCompareList().length;
    // Update any compare count badges if they exist
    document.querySelectorAll('.compare-count').forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-block' : 'none';
    });
  }

  showNotification(message, type = 'success') {
    // Remove existing notifications
    const existing = document.querySelector('.compare-notification');
    if (existing) existing.remove();

    // Create notification
    const notification = document.createElement('div');
    notification.className = `compare-notification compare-notification--${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    // Trigger animation
    setTimeout(() => notification.classList.add('is-visible'), 10);

    // Remove after 3 seconds
    setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.productCompare = new ProductCompare();
  });
} else {
  window.productCompare = new ProductCompare();
}

// Add notification styles
const style = document.createElement('style');
style.textContent = `
  .compare-notification {
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 16px 24px;
    background: #000;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    z-index: 10000;
    transform: translateY(100px);
    opacity: 0;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .compare-notification.is-visible {
    transform: translateY(0);
    opacity: 1;
  }

  .compare-notification--success {
    background: #28a745;
  }

  .compare-notification--warning {
    background: #ff6b6b;
  }

  .compare-notification--error {
    background: #dc3545;
  }

  /* Button Loader */
  .loader-spinner-btn {
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    display: inline-block;
    vertical-align: middle;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @media (max-width: 768px) {
    .compare-notification {
      right: 10px;
      left: 10px;
      bottom: 10px;
      text-align: center;
    }
  }
`;
document.head.appendChild(style);

// ========================================
// QUICK VIEW MODAL FUNCTIONALITY
// ========================================

const quickViewModal = {
  modal: null,
  overlay: null,
  container: null,
  content: null,
  closeBtn: null,
  currentProductHandle: null,

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  },

  setup() {
    this.modal = document.getElementById('quick-view-modal');
    if (!this.modal) {
      console.warn('Quick view modal not found in DOM');
      return;
    }

    this.overlay = this.modal.querySelector('.quick-view-overlay');
    this.container = this.modal.querySelector('.quick-view-container');
    this.content = this.modal.querySelector('.quick-view-content');
    this.closeBtn = this.modal.querySelector('.quick-view-close');

    this.bindEvents();
  },

  bindEvents() {
    // Quick view button clicks
    document.addEventListener('click', (e) => {
      const quickViewBtn = e.target.closest('.insy-quick-view');
      if (quickViewBtn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = quickViewBtn.dataset.productHandle;
        if (handle) {
          this.open(handle);
        }
      }
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-open')) {
        this.close();
      }
    });

    // Prevent modal container clicks from closing
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  },

  async open(handle) {
    this.currentProductHandle = handle;

    // Show modal with loader
    this.modal.classList.add('is-open');
    document.body.classList.add('quick-view-open');

    // Show loader
    this.content.innerHTML = `
      <div class="quick-view-loader">
        <div class="loader-spinner"></div>
        <p>Loading product...</p>
      </div>
    `;

    try {
      // Fetch product data from Shopify Product JSON endpoint
      const response = await fetch(`/products/${handle}.js`);

      if (!response.ok) {
        throw new Error('Failed to load product');
      }

      const product = await response.json();
      this.renderProduct(product);

    } catch (error) {
      console.error('Error loading product:', error);
      this.content.innerHTML = `
        <div class="quick-view-loader">
          <p style="color: #e53935;">Failed to load product. Please try again.</p>
        </div>
      `;
    }
  },

  renderProduct(product) {
    // Get first available variant
    const firstVariant = product.variants[0];
    const formattedPrice = this.formatMoney(firstVariant.price);
    const compareAtPrice = firstVariant.compare_at_price ? this.formatMoney(firstVariant.compare_at_price) : null;

    // Clean description - handle both string and HTML
    let cleanDescription = '';
    if (product.description) {
      if (typeof product.description === 'string') {
        // Strip HTML tags and limit length
        cleanDescription = product.description
          .replace(/<[^>]*>/g, '')
          .trim()
          .substring(0, 300);
        if (product.description.length > 300) {
          cleanDescription += '...';
        }
      }
    }

    // Build variant options HTML with intelligent swatch detection
    let variantsHTML = '';
    if (product.options && product.options.length > 0) {
      // Filter out default "Title" option for products with no variants
      const realOptions = product.options.filter(opt => {
        const optionName = typeof opt === 'string' ? opt : opt.name;
        return optionName && optionName !== 'Title';
      });

      if (realOptions.length > 0) {
        variantsHTML = realOptions.map((option, index) => {
          // Handle both string and object formats
          const optionName = typeof option === 'string' ? option : option.name;
          const optionValues = typeof option === 'string'
            ? [...new Set(product.variants.map(v => v[`option${index + 1}`]))]
            : option.values;

          // Detect if this is a color option that should show swatches
          const isColorOption = this.isColorOption(optionName);
          const swatchMode = window.themeVariables?.settings?.product_card_swatch_mode || 'image';

          return `
            <fieldset class="quick-view-variant-group custom_variant_picker">
              <div class="variant-picker__option-info custom_variant_picker_info">
                <legend class="quick-view-variant-label">${this.escapeHtml(optionName)}:</legend>
              </div>
              <div class="quick-view-variant-options ${isColorOption ? 'is-swatch-mode' : ''}" data-option-index="${index}">
                ${optionValues.map(value => {
                  const variant = product.variants.find(v => v[`option${index + 1}`] === value);
                  const isAvailable = variant && variant.available;
                  const isSelected = index === 0 && value === firstVariant[`option${index + 1}`];

                  // Render color swatches for color options
                  if (isColorOption && swatchMode === 'color') {
                    const colorValue = this.getColorValue(value);
                    return `
                      <button
                        class="quick-view-variant-swatch ${isSelected ? 'selected' : ''}"
                        data-value="${this.escapeHtml(value)}"
                        title="${this.escapeHtml(value)}"
                        ${!isAvailable ? 'disabled' : ''}
                      >
                        <span class="swatch-color" style="background-color: ${colorValue};"></span>
                      </button>
                    `;
                  }
                  // Render image swatches for color options in image mode
                  else if (isColorOption && swatchMode === 'image' && variant && variant.featured_image) {
                    return `
                      <button
                        class="quick-view-variant-image-swatch ${isSelected ? 'selected' : ''}"
                        data-value="${this.escapeHtml(value)}"
                        title="${this.escapeHtml(value)}"
                        ${!isAvailable ? 'disabled' : ''}
                      >
                        <img src="${this.getShopifyImageUrl(variant.featured_image.src, 60)}"
                             alt="${this.escapeHtml(value)}"
                             loading="lazy">
                      </button>
                    `;
                  }
                  // Render text buttons (default)
                  else {
                    return `
                      <button
                        class="quick-view-variant-option ${isSelected ? 'selected' : ''}"
                        data-value="${this.escapeHtml(value)}"
                        ${!isAvailable ? 'disabled' : ''}
                      >
                        ${this.escapeHtml(value)}
                      </button>
                    `;
                  }
                }).join('')}
              </div>
            </fieldset>
          `;
        }).join('');
      }
    }

    // Build gallery HTML using Swiper - match main product section structure
    let galleryHTML = '';
    const images = product.media
      ? product.media.filter(m => m.media_type === 'image').map(m => m.src || m.preview_image?.src)
      : product.images || [];

    if (images.length > 0) {
      galleryHTML = `
        <div class="quick-view-gallery">
          <!-- Main Swiper Wrapper -->
          <div class="qv-main-swiper-wrapper">
            <swiper-container
              class="qv-main-swiper"
              init="false"
              style="--swiper-navigation-color: #000; --swiper-pagination-color: #000">
              ${images.map((imageUrl, i) => `
                <swiper-slide>
                  <img
                    src="${this.getShopifyImageUrl(imageUrl, 800)}"
                    alt="${this.escapeHtml(product.title)} - Image ${i + 1}"
                    loading="${i === 0 ? 'eager' : 'lazy'}"
                  >
                </swiper-slide>
              `).join('')}
            </swiper-container>

            <!-- Custom Navigation Arrows -->
            <div class="qv-swiper-nav-prev">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </div>
            <div class="qv-swiper-nav-next">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          </div>

          <!-- Thumbnails Swiper -->
          ${images.length > 1 ? `
            <swiper-container class="qv-thumbs-swiper" init="false">
              ${images.map((imageUrl, i) => `
                <swiper-slide>
                  <img
                    src="${this.getShopifyImageUrl(imageUrl, 150)}"
                    alt="${this.escapeHtml(product.title)} - Thumb ${i + 1}"
                    loading="lazy"
                  >
                </swiper-slide>
              `).join('')}
            </swiper-container>
          ` : ''}
        </div>
      `;
    }

    // Render product HTML
    this.content.innerHTML = `
      <div class="quick-view-product" data-product-id="${product.id}">
        ${galleryHTML}
        <div class="quick-view-info">
          <h2 class="quick-view-title" id="quick-view-title">${this.escapeHtml(product.title)}</h2>

          <div class="quick-view-price-wrapper">
            <span class="product_block_price_title">${window.themeVariables.strings.priceTitle}</span>
            <div class="quick-view-price-wrapper">
              ${compareAtPrice ? `<span class="quick-view-compare-price">${compareAtPrice}</span>` : ''}
              <span class="quick-view-price" id="quick-view-price">${formattedPrice}</span>
            </div>
          </div>

          <form class="quick-view-form" data-product-handle="${product.handle}">
            <input type="hidden" name="id" id="quick-view-variant-id" value="${firstVariant.id}">

            ${variantsHTML}

            <div class="quick-view-quantity">
              <label class="quick-view-quantity-label product_block_quantity_title">${window.themeVariables.strings.quantity}</label>
              <div class="quantity-selector">
                <button type="button" class="quantity-selector__button quantity-decrease" aria-label="Decrease quantity">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M1 5h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
                <input
                  type="number"
                  class="quantity-selector__input"
                  id="quick-view-quantity"
                  name="quantity"
                  value="1"
                  min="1"
                  step="1"
                  aria-label="Quantity"
                >
                <button type="button" class="quantity-selector__button quantity-increase" aria-label="Increase quantity">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M5 1v8M1 5h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>

            <button
              type="button"
              class="quick-view-add-to-cart"
              id="quick-view-add-btn"
              ${!firstVariant.available ? 'disabled' : ''}
            >
              ${firstVariant.available ? window.themeVariables.strings.addToCart : window.themeVariables.strings.soldOut}
            </button>
          </form>

          ${cleanDescription ? `<div class="quick-view-description">${this.escapeHtml(cleanDescription)}</div>` : ''}

          <a href="/products/${product.handle}" class="quick-view-view-full">${window.themeVariables.strings.viewDetails}</a>
        </div>
      </div>
    `;

    // Initialize interactions
    this.initVariantSelection(product);
    this.initSwiper();
    this.initQuantitySelector();
    this.initAddToCart();
  },

  escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  },

  isColorOption(optionName) {
    if (!optionName) return false;
    const lowerName = optionName.toLowerCase();

    // Check for common color-related names
    const colorKeywords = ['color', 'colour', 'צבע'];
    if (colorKeywords.some(keyword => lowerName.includes(keyword))) {
      return true;
    }

    // Check custom trigger names from theme settings
    if (window.themeVariables?.settings?.variant_trigger_names) {
      const triggerNames = window.themeVariables.settings.variant_trigger_names
        .toLowerCase()
        .split(/[\n,]+/)
        .map(name => name.trim());
      return triggerNames.some(trigger => lowerName === trigger);
    }

    return false;
  },

  getColorValue(colorName) {
    if (!colorName) return '#cccccc';

    // Try to get color from theme settings config
    if (window.themeVariables?.settings?.color_swatch_config) {
      const config = window.themeVariables.settings.color_swatch_config;
      const lines = config.split(/[\n,]+/);

      for (const line of lines) {
        const parts = line.split(':');
        if (parts.length === 2) {
          const configName = parts[0].trim().toLowerCase();
          const configColor = parts[1].trim();
          if (configName === colorName.toLowerCase()) {
            return configColor;
          }
        }
      }
    }

    // Fallback: try to use the color name directly (works for named colors like "red", "blue")
    return colorName.toLowerCase().replace(/\s+/g, '');
  },

  getShopifyImageUrl(url, size) {
    if (!url) return '';

    // Shopify CDN image URL format
    // Remove any existing size suffix and add new one
    const cleanUrl = url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)\./g, '.');

    // Add size suffix before file extension
    if (size) {
      return cleanUrl.replace(/(\.[^.]+)$/, `_${size}x$1`);
    }

    return cleanUrl;
  },

  formatMoney(cents) {
    // Simple money formatting (customize based on shop currency)
    return `$${(cents / 100).toFixed(2)}`;
  },

  initVariantSelection(product) {
    // Select all variant option types (text buttons, color swatches, image swatches)
    const variantOptions = this.content.querySelectorAll('.quick-view-variant-option, .quick-view-variant-swatch, .quick-view-variant-image-swatch');

    variantOptions.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        // Update selected state for all button types in this group
        const parent = option.closest('.quick-view-variant-options');
        parent.querySelectorAll('.quick-view-variant-option, .quick-view-variant-swatch, .quick-view-variant-image-swatch').forEach(btn => {
          btn.classList.remove('selected');
        });
        option.classList.add('selected');

        // Get all selected options
        const selectedOptions = [];
        this.content.querySelectorAll('.quick-view-variant-options').forEach(group => {
          const selected = group.querySelector('.selected');
          if (selected) {
            selectedOptions.push(selected.dataset.value);
          }
        });

        // Find matching variant
        const matchingVariant = product.variants.find(variant => {
          return selectedOptions.every((value, index) => {
            return variant[`option${index + 1}`] === value;
          });
        });

        if (matchingVariant) {
          // Update price
          const priceElement = document.getElementById('quick-view-price');
          if (priceElement) {
            priceElement.textContent = this.formatMoney(matchingVariant.price);
          }

          // Update variant ID
          const variantInput = document.getElementById('quick-view-variant-id');
          if (variantInput) {
            variantInput.value = matchingVariant.id;
          }

          // Update add to cart button
          const addBtn = document.getElementById('quick-view-add-btn');
          if (addBtn) {
            if (matchingVariant.available) {
              addBtn.disabled = false;
              addBtn.textContent = window.themeVariables.strings.addToCart;
            } else {
              addBtn.disabled = true;
              addBtn.textContent = window.themeVariables.strings.soldOut;
            }
          }

          // Update image if variant has featured image - navigate Swiper
          if (matchingVariant.featured_image || (matchingVariant.featured_media && matchingVariant.featured_media.preview_image)) {
            const mainSwiper = this.content.querySelector('.qv-main-swiper');
            if (mainSwiper && mainSwiper.swiper) {
              // Get the image URL to match
              const variantImageUrl = matchingVariant.featured_image?.src ||
                                    matchingVariant.featured_image ||
                                    matchingVariant.featured_media?.preview_image?.src;

              // Find the slide index with this image
              const slides = mainSwiper.querySelectorAll('swiper-slide img');
              let slideIndex = 0;
              slides.forEach((img, index) => {
                if (img.src.includes(variantImageUrl) || variantImageUrl.includes(img.src.split('?')[0].split('_')[0])) {
                  slideIndex = index;
                }
              });

              // Navigate to the slide
              mainSwiper.swiper.slideTo(slideIndex);
            }
          }
        }
      });
    });
  },

  initSwiper() {
    // Wait for next tick to ensure DOM is ready
    setTimeout(() => {
      const mainSwiperEl = this.content.querySelector('.qv-main-swiper');
      const thumbsSwiperEl = this.content.querySelector('.qv-thumbs-swiper');

      if (!mainSwiperEl) {
        console.log('Main swiper not found');
        return;
      }

      if (mainSwiperEl && thumbsSwiperEl) {
        // 1. Initialize Thumbs first
        const thumbsParams = {
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          grabCursor: true,
          breakpoints: {
            320: { slidesPerView: 3 },
            480: { slidesPerView: 4 },
            768: { slidesPerView: 5 }
          }
        };
        Object.assign(thumbsSwiperEl, thumbsParams);
        thumbsSwiperEl.initialize();

        // Wait for thumbs to be fully initialized
        setTimeout(() => {
          // 2. Initialize Main Swiper with thumbs (NO navigation in config)
          const mainParams = {
            pagination: {
              clickable: true,
              dynamicBullets: true
            },
            thumbs: {
              swiper: thumbsSwiperEl.swiper  // Pass the swiper instance, not the element
            },
            spaceBetween: 10
          };
          Object.assign(mainSwiperEl, mainParams);
          mainSwiperEl.initialize();

          // 3. Manually connect custom navigation buttons after initialization
          setTimeout(() => {
            const prevButton = this.content.querySelector('.qv-swiper-nav-prev');
            const nextButton = this.content.querySelector('.qv-swiper-nav-next');

            if (prevButton && nextButton && mainSwiperEl.swiper) {
              prevButton.addEventListener('click', () => {
                mainSwiperEl.swiper.slideNext();
              });

              nextButton.addEventListener('click', () => {
                mainSwiperEl.swiper.slidePrev();
              });

              // Update button states (swapped because we swapped the methods)
              mainSwiperEl.swiper.on('slideChange', () => {
                if (mainSwiperEl.swiper.isEnd) {
                  prevButton.classList.add('swiper-button-disabled');
                } else {
                  prevButton.classList.remove('swiper-button-disabled');
                }

                if (mainSwiperEl.swiper.isBeginning) {
                  nextButton.classList.add('swiper-button-disabled');
                } else {
                  nextButton.classList.remove('swiper-button-disabled');
                }

                // Keep active thumbnail visible by scrolling thumbs swiper
                if (thumbsSwiperEl && thumbsSwiperEl.swiper) {
                  const activeIndex = mainSwiperEl.swiper.activeIndex;
                  thumbsSwiperEl.swiper.slideTo(activeIndex);
                }
              });

              // Initial state (swapped)
              if (mainSwiperEl.swiper.isEnd) {
                prevButton.classList.add('swiper-button-disabled');
              }
              if (mainSwiperEl.swiper.isBeginning) {
                nextButton.classList.add('swiper-button-disabled');
              }

              console.log('Quick View Swiper initialized with manual navigation');
            }
          }, 50);
        }, 100);
      } else {
        // Initialize without thumbs
        const mainParams = {
          pagination: {
            clickable: true,
            dynamicBullets: true
          },
          spaceBetween: 10
        };
        Object.assign(mainSwiperEl, mainParams);
        mainSwiperEl.initialize();

        // Manually connect custom navigation buttons
        setTimeout(() => {
          const prevButton = this.content.querySelector('.qv-swiper-nav-prev');
          const nextButton = this.content.querySelector('.qv-swiper-nav-next');

          if (prevButton && nextButton && mainSwiperEl.swiper) {
            prevButton.addEventListener('click', () => {
              mainSwiperEl.swiper.slideNext();
            });

            nextButton.addEventListener('click', () => {
              mainSwiperEl.swiper.slidePrev();
            });

            // Update button states (swapped because we swapped the methods)
            mainSwiperEl.swiper.on('slideChange', () => {
              if (mainSwiperEl.swiper.isEnd) {
                prevButton.classList.add('swiper-button-disabled');
              } else {
                prevButton.classList.remove('swiper-button-disabled');
              }

              if (mainSwiperEl.swiper.isBeginning) {
                nextButton.classList.add('swiper-button-disabled');
              } else {
                nextButton.classList.remove('swiper-button-disabled');
              }
            });

            // Initial state (swapped)
            if (mainSwiperEl.swiper.isEnd) {
              prevButton.classList.add('swiper-button-disabled');
            }
            if (mainSwiperEl.swiper.isBeginning) {
              nextButton.classList.add('swiper-button-disabled');
            }

            console.log('Quick View Swiper initialized without thumbs');
          }
        }, 50);
      }
    }, 200);
  },

  initQuantitySelector() {
    const quantityInput = document.getElementById('quick-view-quantity');
    const decreaseBtn = this.content.querySelector('.quantity-decrease');
    const increaseBtn = this.content.querySelector('.quantity-increase');

    if (!quantityInput || !decreaseBtn || !increaseBtn) return;

    // Handle decrease button
    decreaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
      this.updateQuantityButtonStates();
    });

    // Handle increase button
    increaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
      this.updateQuantityButtonStates();
    });

    // Handle manual input
    quantityInput.addEventListener('input', () => {
      let value = parseInt(quantityInput.value);
      if (isNaN(value) || value < 1) {
        quantityInput.value = 1;
      }
      this.updateQuantityButtonStates();
    });

    // Initialize button states
    this.updateQuantityButtonStates();
  },

  updateQuantityButtonStates() {
    const quantityInput = document.getElementById('quick-view-quantity');
    const decreaseBtn = this.content.querySelector('.quantity-decrease');

    if (!quantityInput || !decreaseBtn) return;

    const currentValue = parseInt(quantityInput.value) || 1;
    decreaseBtn.disabled = currentValue <= 1;
  },

  initAddToCart() {
    const addBtn = document.getElementById('quick-view-add-btn');
    if (!addBtn) return;

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const variantInput = document.getElementById('quick-view-variant-id');
      const variantId = variantInput?.value;

      if (!variantId) {
        alert('Please select a variant');
        return;
      }

      await this.addToCart(variantId, addBtn);
    });
  },

  async addToCart(variantId, button) {
    const originalText = button.textContent;
    button.textContent = window.themeVariables.strings.adding;
    button.disabled = true;

    // Trigger theme loading
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', {
      bubbles: true
    }));

    try {
      // Get quantity from input
      const quantityInput = document.getElementById('quick-view-quantity');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      const params = new URLSearchParams();
      params.append('id', variantId);
      params.append('quantity', quantity.toString());

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: params.toString()
      });

      if (!response.ok) {
        const error = await response.json();
        throw error;
      }

      const data = await response.json();
      console.log('Product added to cart from quick view:', data);

      // Close modal
      this.close();

      // Wait a bit before opening drawer
      setTimeout(() => {
        // Open cart drawer
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          setTimeout(() => {
            if (typeof drawer.show === 'function') {
              drawer.show();
            } else {
              drawer.classList.add('is-open');
              drawer.setAttribute('open', 'true');
            }
          }, 300);
        }

        // Update header cart
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            document.querySelectorAll('cart-count').forEach(el => {
              el.innerText = cart.item_count;
            });
            document.querySelectorAll('cart-dot').forEach(el => {
              if (cart.item_count > 0) {
                el.classList.add('is-visible');
              }
            });
          });

        // End loading
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
          bubbles: true
        }));
      }, 300);

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(error.description || error.message || 'Failed to add item to cart');
      button.textContent = originalText;
      button.disabled = false;

      // End loading
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', {
        bubbles: true
      }));
    }
  },

  close() {
    this.modal.classList.remove('is-open');
    document.body.classList.remove('quick-view-open');

    // Clear content after animation
    setTimeout(() => {
      this.content.innerHTML = `
        <div class="quick-view-loader">
          <div class="loader-spinner"></div>
          <p>Loading product...</p>
        </div>
      `;
    }, 300);
  }
};

// Initialize Quick View
quickViewModal.init();